export const TBL_HEADERS = [
  {
    name: "",
    variable: "",
  },
  {
    name: "User Name",
    variable: "UserName",
  },
  {
    name: "Activity Status",
    variable: "ActivityAction",
  },
  {
    name: "Activity Name",
    variable: "ActivityName",
  },
  {
    name: "Activity Date",
    variable: "ActivityDate",
  },
  {
    name: "Activity Time",
    variable: "ActivityTime",
  },
];
